module.exports = __webpack_public_path__ + "img/Support-skill-331.b3748146.png";